import { useQuery } from 'react-query';
import { QueryKeys } from '../../../../api/query.keys';
import SubscriptionsAPI from '../../../../api/services/subscriptions';

const STALE_TIME = 5 * 60 * 1000; // 5 minutes

/**
 * Hook for fetching web subscription tiers
 */
export const useWebTiers = () => useQuery(
    QueryKeys.SubscriptionWebTiers,
    () => SubscriptionsAPI.getWebTiers(),
    {
      retry: false,
      staleTime: STALE_TIME,
      select: (response) => response.data,
    },
  );

export const useMyTier = () => useQuery(
    QueryKeys.SubscriptionMyTiers,
    () => SubscriptionsAPI.getMyTiers(),
    {
      retry: false,
      staleTime: STALE_TIME,
      select: (response) => response.data,
    },
  );

/**
 * Hook for fetching mobile subscription tiers
 */
export const useMobileTiers = () => useQuery(
    QueryKeys.SubscriptionMobileTiers,
    () => SubscriptionsAPI.getMobileTiers(),
    {
      retry: false,
      staleTime: STALE_TIME,
      select: (response) => response.data,
    },
  );

/**
 * Hook for fetching web subscription features
 */
export const useWebFeatures = () => useQuery(
    QueryKeys.SubscriptionWebFeatures,
    () => SubscriptionsAPI.getWebFeatureList(),
    {
      retry: false,
      staleTime: STALE_TIME,
      select: (response) => response.data,
    },
  );

/**
 * Hook for fetching mobile subscription features
 */
export const useMobileFeatures = () => useQuery(
    QueryKeys.SubscriptionMobileFeatures,
    () => SubscriptionsAPI.getMobileFeatureList(),
    {
      retry: false,
      staleTime: STALE_TIME,
      select: (response) => response.data,
    },
  );

/**
 * Combined hook for fetching all subscription data
 */
export const useSubscriptionsData = () => {
  const webTiers = useWebTiers();
  const mobileTiers = useMobileTiers();
  const webFeatures = useWebFeatures();
  const mobileFeatures = useMobileFeatures();

  return {
    webTiers,
    mobileTiers,
    webFeatures,
    mobileFeatures,
    isLoading: (
      webTiers.isLoading ||
      mobileTiers.isLoading ||
      webFeatures.isLoading ||
      mobileFeatures.isLoading
    ),
    error: webTiers.error || mobileTiers.error || webFeatures.error || mobileFeatures.error,
  };
};
